var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeakIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.5h20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11h8.8l1.2 1.3 1.2-1.3H22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4v8.5M22 4v8.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.3l-.9-1.9 1.3-1.2-.8-1.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5c-1.5 2.1-2.5 3.4-2.5 4.6a2.5 2.5 0 0 0 5 0c0-1.2-1-2.5-2.5-4.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeakIcon);
export default __webpack_public_path__ + "static/media/leakIcon.3e5518bb96242972cae3222fac989a59.svg";
export { ForwardRef as ReactComponent };